import React from "react";
import { Checkbox, CollapsibleItem } from "react-materialize";
import { useInfo } from "context/InfoContext";

export default function DashboardDestinationContent({ boxName, userData, handleEvents }) {
  const { filters, filterData } = useInfo();
  // const isCannotEdit =
  //   userData?.user_sess?.userCanAccessHrAssign ||
  //   userData?.user_sess?.isAdmin ||
  //   userData?.idu === filters?.idu
  //     ? false
  //     : true;
  return (
    <CollapsibleItem
      key={"destination-items-content-" + boxName + "-" + filters.key_form}
      className="collap-item"
      expanded={true}
      header={<h6>Destination</h6>}
      //icon={<Icon>filter_drama</Icon>}
      node="div"
    >
      <div className="row">
        {filterData.data.countries.map((item, i) => {
          const countryId = item.id;
          let checked = false;
          if (
            filters?.user_countries_access &&
            (filters.user_countries_access.indexOf(countryId.toString()) > -1 ||
              filters.user_countries_access.indexOf(countryId) > -1)
          ) {
            checked = true;
          }
          return (
            <div
              key={"destination-item-" + i}
              className="col s4 destination-item"
            >
              <Checkbox
                checked={checked}
                filledIn
                id={"destination-item-" + i}
                name="user_countries_access"
                label={item.name}
                value={item.id.toString()}
                onChange={handleEvents.OnChange}
              />
            </div>
          );
        })}
      </div>
    </CollapsibleItem>
  );
}
